<!--  -->
<template>
  <div class="result">
    <div class="success">
      <img src="../../assets/pays.png" alt />
      <p class="txt1">支付成功，请在"导出记录"中下载已导出的数据</p>
      <p class="txt2">您可在“个人中心-导出记录”中查看已购买的数据，并可下载该数据</p>
      <div class="btn">
        <el-button size="small" type="primary" @click="goHome" class="goHome">返回首页</el-button>
        <el-button size="small" @click="goData" class="goData">导出记录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'result',
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    goHome() {
      this.$router.push({
        path: '/',
      })
    },
    goData() {
      this.$router.push({
        path: '/mydata',
      })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {
    this.$emit('getStep', 3)
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.result {
  width: 1200px;
  background: #fff;
  border-radius: 4px;
  margin: 20px auto;
  font-size: 14px;
  padding: 50px 50px 230px;
  .success {
    /deep/.el-button {
      width: 140px;
    }
    .txt1 {
      font-size: 20px;
      color: #333;
      margin-bottom: 30px;
      margin-top: 20px;
    }
    .txt2 {
      font-size: 14px;
      color: #999;
      line-height: 22px;
    }
    .btn {
      margin-top: 30px;
      .goHome {
        background: #0f4d72;
        border-color: #0f4d72;
        &:hover {
          background: #105e8c;
          border-color: #105e8c;
        }
      }
      .goData {
        background: #f4f4f4;
        border-color: #f4f4f4;
        color: #666;
        &:hover {
          background: #0f4d72;
          border-color: #0f4d72;
          color: #fff;
        }
      }
    }
  }
}
</style>
